/* UserTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import "./UserTrigger.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
// PLEASE NOTE: This file is sync-loaded with the trigger components. Only add components here that
// are necessary for the main render of the trigger component to help maintain bundle size.

/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { cx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { bgColor } from './constants';
var styles = {
  cardWrapper: "_2rkoglpi _1bsb1gwv",
  spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm"
};
export var CardWrapper = function CardWrapper(_ref) {
  var children = _ref.children,
    role = _ref.role,
    testId = _ref.testId,
    labelledBy = _ref.labelledBy;
  return fg('compiled-migration-profilecard') ? /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.cardWrapper),
    backgroundColor: 'elevation.surface.overlay',
    role: role,
    testId: testId,
    "aria-labelledby": labelledBy
  }, children) : /*#__PURE__*/React.createElement(CardWrapperLegacy, {
    "data-testid": testId,
    role: role,
    "aria-labelledby": labelledBy
  }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var CardWrapperLegacy = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\tborder-radius: ", ";\n\twidth: 360px;\n"])), bgColor, "var(--ds-border-radius, 3px)");
export var SpinnerContainer = function SpinnerContainer(_ref2) {
  var children = _ref2.children,
    testId = _ref2.testId;
  return fg('compiled-migration-profilecard') ? /*#__PURE__*/React.createElement(Box, {
    testId: testId,
    xcss: cx(styles.spinnerContainer)
  }, children) : /*#__PURE__*/React.createElement(SpinnerContainerLegacy, {
    "data-testid": testId
  }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var SpinnerContainerLegacy = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\talign-items: center;\n\tdisplay: flex;\n\theight: 96px;\n\tjustify-content: center;\n\tposition: relative;\n"])));